// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.amendment.AmendmentResponse */
/* istanbul ignore next */
@GandalfModel
export class AmendmentResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	amendmentId!: number | null;

	@GandalfConstantDecorator(constants.AmendmentSource)
	@GandalfProperty({ designType: constants.AmendmentSource })
	amendmentSource!: constants.AmendmentSource | null;

	@GandalfProperty({ designType: String })
	amendmentSourceText!: string | null;

	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfProperty({ propertyType: 'LocalDateTime', designType: Date })
	requestDate!: Date | null;

	@GandalfConstantDecorator(constants.AmendmentStatus)
	@GandalfProperty({ designType: constants.AmendmentStatus })
	status!: constants.AmendmentStatus | null;

	@GandalfProperty({ propertyType: 'LocalDateTime', designType: Date })
	statusChangeDate!: Date | null;

}
